import { render, staticRenderFns } from "./auth-user.vue?vue&type=template&id=9214155c&scoped=true"
import script from "./auth-user.vue?vue&type=script&lang=js"
export * from "./auth-user.vue?vue&type=script&lang=js"
import style0 from "./auth-user.vue?vue&type=style&index=0&id=9214155c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9214155c",
  null
  
)

export default component.exports